import { IDanhSachLopTinChiChuyenLopRequest } from "../../model/request/lop-tin-chi/IDanhSachLopTinChiChuyenLopRequest";
import { apiClient } from "../apiClient";

const DANH_SACH_LOP_TIN_CHI_API = "danh-sach-lop-tin-chi";
export const danhSachLopTinChiApi = {
    ChuyenLop: (request: IDanhSachLopTinChiChuyenLopRequest) => apiClient.post(`${DANH_SACH_LOP_TIN_CHI_API}/chuyen-lop`, request),
    DangKyTuDongLopHanhChinh: (id_lop_tcs: number[]) => apiClient.post(`${DANH_SACH_LOP_TIN_CHI_API}/dang-ky-tu-dong/lop-hanh-chinh`, id_lop_tcs),
}